angular.module('bmsApp.directives').factory('LeavingPromptResponseSvc', [
	'$rootScope',
	'$modal',
	'CRUDSvc',
	function (
		$rootScope,
		$modal,
		CRUDSvc) {

	return {
		showLeavingPromptResponseModal: function (visitType, visit) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/leaving-prompt-response/templates/LeavingPromptResponseModal.html',
				controller: 'LeavingPromptResponseModalCtrl',
				size: 'md',
				scope: $rootScope,
				resolve: {
					visitType: function () {
						return angular.copy(visitType)
					},
					visit: function () {
						return angular.copy(visit)
					},
				}
			});
		},

		index: function (params) {
			return CRUDSvc.get('api/leaving-prompt-response/index', params);
		},
	};

}]);
